import React from 'react';

import { useParams } from 'react-router-dom';

//import { MOSAiC } from './MOSAiC';

/**
 * Route wrapper for MOSAiC that extracts patientId from URL parameters
 */
export const MOSAiCRouteWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const patientId = id ? parseInt(id, 10) : null;

  //return <MOSAiC embeddedMode patientId={patientId} />;
  return null;
};

MOSAiCRouteWrapper.displayName = 'MOSAiCRouteWrapper';
